import { Box, Grid, Paper, Typography } from '@mui/material';
import { ItemWithId } from 'components/HMRC/data/types';
import { COLORS } from 'services/constants/colors';
import { EasTableValue } from 'ui/EasTable/EasTableRow/EasTableValue';
import { TEasFullDataComponentProps } from './types';

export const EasFullDataComponent = <T extends ItemWithId>({
	tableStructure,
	data,
	header,
}: TEasFullDataComponentProps<T>) => {
	return (
		<Paper
			sx={{
				margin: '0px 10px 20px 10px',
				maxWidth: 'calc(100vw - 20px)',
				overflowX: 'auto',
			}}
		>
			<Box sx={{ width: 'auto', minWidth: '1000px' }}>
				<Box sx={{ borderRadius: '12px' }}>
					<Box
						sx={{
							backgroundColor: 'primary.light',
							p: '4px 4px 4px 8px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: '10px',
						}}
					>
						{header && header}
					</Box>

					<Box sx={{ padding: '10px' }}>
						<Grid container spacing={1}>
							{tableStructure.map((filter) => {
								if (filter.selector === 'actions') return null;
								const { selector } = filter;
								if (!filter.showInFoolData) return null;
								return (
									<Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={String(filter.selector)}>
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'start',
												gap: '10px',
												alignItems: 'center',
											}}
										>
											<Typography
												variant="body2"
												sx={{ color: COLORS.font_status, fontSize: '0.75rem' }}
											>
												{filter.name}:
											</Typography>
											<EasTableValue
												type={filter.type}
												tableStructureItem={filter}
												value={filter.value ? filter.value(data) : data?.[selector]}
												item={data ?? ({} as T)}
												size="m"
											/>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Box>
				</Box>
			</Box>
		</Paper>
	);
};
